import React from 'react'
import * as R from 'ramda'

import { DetailsCard } from 'components/shared/DetailsCard/DetailsCard'

export const CompetencyDescription = ({ competencies }) =>
  R.map(
    ({ description, label }) => (
      <React.Fragment key={label}>
        <DetailsCard.Subtitle>{label}</DetailsCard.Subtitle>
        <DetailsCard.Text>{description}</DetailsCard.Text>
      </React.Fragment>
    ),
    competencies,
  )
